import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
export const defaultSegmentType = segments => {
  const firstSegment = segments[0];
  const definitions = firstSegment.definitions;
  const firstKey = _Object$keys(definitions)[0];
  const {
    type
  } = definitions[firstKey];
  return type;
};
export const defaultSegmentTypeValue = segments => {
  return segments[0] ? segments[0].valueType : "";
};
export const getSegmentName = (segmentData, segmentId) => {
  const obtainedSegment = _filterInstanceProperty(segmentData).call(segmentData, segment => segment.id == segmentId);
  return obtainedSegment[0].name;
};
export const getSegmentOperators = (segmentData, segmentId) => {
  const obtainedSegment = _filterInstanceProperty(segmentData).call(segmentData, segment => segment.id == segmentId);
  return obtainedSegment[0].definitions;
};
export const getSegmentType = (segmentData, operator, segmentId) => {
  const obtainedSegment = _filterInstanceProperty(segmentData).call(segmentData, segment => segment.id == segmentId);
  return obtainedSegment[0].definitions[operator].type;
};
export const parseOperator = (operator, type) => {
  const parsing = {
    ">": "larger than",
    "<": "less than",
    "=": "is",
    range: type === "multi-value" ? "is between" : "select multiple"
  };
  return parsing[operator];
};
export const parseJoin = join => {
  const parsing = {
    or: "any",
    and: "all"
  };
  return parsing[join];
};
export const inverseJoin = join => {
  const parsing = {
    or: "all",
    and: "any"
  };
  return parsing[join];
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("defaultSegmentType", defaultSegmentType);
  _Handlebars.registerHelper("defaultSegmentTypeValue", defaultSegmentTypeValue);
  _Handlebars.registerHelper("getSegmentName", getSegmentName);
  _Handlebars.registerHelper("getSegmentOperators", getSegmentOperators);
  _Handlebars.registerHelper("getSegmentType", getSegmentType);
  _Handlebars.registerHelper("parseOperator", parseOperator);
  _Handlebars.registerHelper("parseJoin", parseJoin);
  _Handlebars.registerHelper("inverseJoin", inverseJoin);
};